import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6deef317"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"display":"none"},
  id: "btnPrintElementOrder"
}
const _hoisted_2 = { style: {"display":"none"} }
const _hoisted_3 = {
  ref: "printElementOrder",
  id: "printElementOrder"
}
const _hoisted_4 = {
  key: 0,
  id: "invoice-POS"
}
const _hoisted_5 = { class: "table-order" }
const _hoisted_6 = { class: "orderNb" }
const _hoisted_7 = {
  key: 0,
  id: "bot"
}
const _hoisted_8 = { id: "table" }
const _hoisted_9 = { class: "table-order" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "tabletitle tabletitle-header-products" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "qproduct" }, [
    /*#__PURE__*/_createElementVNode("b", null, "QxProduit")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "price" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Prix TTC")
  ])
], -1))
const _hoisted_11 = { class: "tabletitle tabletitle-list-products font-weight-bold" }
const _hoisted_12 = { class: "text-left width-element-left tableitem" }
const _hoisted_13 = { class: "itemtext itemtext-item-product" }
const _hoisted_14 = { class: "text-left tableitem" }
const _hoisted_15 = {
  key: 0,
  class: "subelement-type"
}
const _hoisted_16 = {
  key: 0,
  class: "itemtext itemtext-subElement"
}
const _hoisted_17 = {
  key: 1,
  class: "itemtext itemtext-subElement"
}
const _hoisted_18 = {
  key: 1,
  class: "subelement-type"
}
const _hoisted_19 = { class: "itemtext itemtext-subElement" }
const _hoisted_20 = { style: {"float":"right"} }
const _hoisted_21 = { class: "itemtext itemtext-subElement-price" }
const _hoisted_22 = { class: "text-right tableitem border-unset" }
const _hoisted_23 = {
  key: 0,
  class: "itemtext itemtext-promo-product itemtext-price"
}
const _hoisted_24 = { class: "itemtext itemtext-promo-product itemtext-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_1, [
      _createTextVNode("Print local range")
    ])), [
      [_directive_print, '#printElementOrder']
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.statePrintElementOrder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("strong", null, "Commande n° " + _toDisplayString(_ctx.statePrintElementOrder?.order_id), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.statePrintElementOrder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("table", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("tr", _hoisted_11, [
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.statePrintElementOrder?.quantity) + " x " + _toDisplayString(_ctx.statePrintElementOrder?.finalName), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statePrintElementOrder.sub_elements_order, (subElement) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: subElement.id,
                                class: "subelement border-dash-top"
                              }, [
                                _createElementVNode("div", _hoisted_14, [
                                  (subElement.type == 'ing')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                        (subElement?.sub_product?.group?.max != null)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(subElement.sub_product?.name), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(subElement.sub_product?.name), 1))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (subElement.type == 'sup')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(subElement.quantity) + " x " + _toDisplayString(subElement.sub_product?.name), 1),
                                        _createElementVNode("span", _hoisted_20, [
                                          _createElementVNode("span", _hoisted_21, _toDisplayString(subElement.price.toFixed(2)) + " € ", 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            (_ctx.statePrintElementOrder.discountPromotion)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.statePrintElementOrder?.discountPromotion?.TotalPriceWithSubProducts?.toFixed(2)) + " € ", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.statePrintElementOrder.total_amount_element_subelements?.toFixed(2)) + " € ", 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ])
  ], 64))
}